const i = {
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "size-rem",
            "size-56",
            "size-62",
            "size-75",
            "size-87",
            "size-100",
            "size-112",
            "size-125",
            "size-150",
            "size-175",
            "size-200",
            "size-225",
            "size-250",
            "size-275",
            "size-300",
            "size-350",
            "size-400",
            "size-450",
            "size-500",
            "size-600",
            "size-base"
          ]
        }
      ],
      "font-weight": [
        { font: ["weight-normal", "weight-bold", "weight-bolder"] }
      ],
      "outline-w": [
        { outline: ["width-hairline", "width-sm", "width-md", "width-lg"] }
      ]
    },
    conflictingClassGroups: { px: ["ps", "pe"] },
    theme: {
      borderWidth: ["width-hairline", "width-sm", "width-md", "width-lg"],
      borderRadius: ["none", "xs", "sm", "md", "lg", "xl", "pill", "circle"]
    }
  },
  override: {
    conflictingClassGroups: { "font-size": [] },
    conflictingClassGroupModifiers: { "font-size": [] }
  }
};
export {
  i as twMergeConfig
};
